import { store } from '@betacrew/jars-flux'
import { W8_MODALS_LOADING_STATES } from './constants';

export const componentKey = "RECIPIENT/W8_REQUESTS"

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {

        setBulkW8RequestConfirmationModal: (state, action) => {
            state.bulkW8RequestConfirmationModal = action.payload
        },

        setGetW8FormsModalOpen: (state, action) => {
            state.getW8FormsModalOpen = action.payload
        },

        setProceedWithW8RequestModalOpen: (state, action) => {
            state.proceedWithW8RequestModalOpen = action.payload
        },

        setW8FormAllRequiredFieldsTouched: (state, action) => {
            state.W8FormInformation.allRequiredFieldsTouched = action.payload
        },

        setPrepayRequestModalOpen: (state, action) => {
            state.prepayRequestModalOpen = action.payload
        },

        setPayWithPrepayModalOpen: (state, action) => {
            state.payWithPrepayModalOpen = action.payload
        },

        setW8Forms: (state, action) => {
            state.w8Forms = action.payload
        },

        setRequestedCount: (state, action) => {
            state.requestedCount = action.payload
        },

        setPayWithPaymentModalOpen: (state, action) => {
            state.payWithPaymentModalOpen = action.payload
        },

        setEstimedTaxModalOpen: (state, action) => {
            state.estimedTaxModalOpen = action.payload
        },

        setPrepayRequestFieldsTouch: (state, action) => {
            state.prepayRequestsInformation.allRequiredFieldsTouched = action.payload
        },

        setW8RequestedCountModalOpen: (state, action) => {
            state.w8RequestedCountModalOpen = action.payload
        },

        setSelectW8Form: (state, action) => {
            let W8FormInformation = { ...state.W8FormInformation };

            Object.entries(action.payload).map(([key, value]) => {
                W8FormInformation = {
                    ...state.W8FormInformation,
                    [key]: {
                        ...state.W8FormInformation[key],
                        ...value
                    },
                };

                state.W8FormInformation = W8FormInformation;
            })
        },

        setPrepayRequests: (state, action) => {
            let prepayRequestsInformation = { ...state.prepayRequestsInformation };

            Object.entries(action.payload).map(([key, value]) => {
                prepayRequestsInformation = {
                    ...state.prepayRequestsInformation,
                    [key]: {
                        ...state.prepayRequestsInformation[key],
                        ...value
                    },
                };

                state.prepayRequestsInformation = prepayRequestsInformation;
            })
        },

        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setBuyingPlan: (state, action) => {
            state.buyingPlan = action.payload;
        },

        setW8Fees: (state, action) => {
            state.w8Fees = action.payload;
        },

        setIsSelectAll: (state, action) => {
            state.isSelectAll = action.payload;
        },

        setHasEnoughRequests: (state, action) => {
            state.hasEnoughRequests = action.payload;
        },

        setShowUpdateRecipientEmailModal: (state, action) => {
            state.showUpdateRecipientEmailModal = action.payload
        },
        setRecipientEmail: (state, action) => {
            state.RecipientEmail = { ...state.RecipientEmail, ...action.payload }
        },
        setShowContactUsModal: (state, action) => {
            state.showContactUsModal = action.payload;
        }

    },
    initialReducerState: {
        loadingState: { state: W8_MODALS_LOADING_STATES.FETCH_W8_FORMS_READY },

        // W8 modal states
        bulkW8RequestConfirmationModal: false,
        getW8FormsModalOpen: false,
        proceedWithW8RequestModalOpen: false,
        w8RequestedCountModalOpen: false,
        prepayRequestModalOpen: false,
        payWithPrepayModalOpen: false,
        payWithPaymentModalOpen: false,
        estimedTaxModalOpen: false,
        w8Forms: [],

        displayPlansView: true,
        paymentInformation: {},

        requestedCount: {
            bulkW8Requests: 0,
            AcceptedW8Requests: 0
        },

        W8FormInformation: {
            allRequiredFieldsTouched: false,

            selectW8Form: {
                label: "",
                value: "",
                errors: {},
                rules: { required: true }
            }
        },

        prepayRequestsInformation: {
            allRequiredFieldsTouched: false,

            prepayRequests: {
                label: "",
                value: "",
                errors: {},
                rules: { required: true }
            }
        },

        buyingPlan: false,
        w8Fees: 0,
        isSelectAll: false,
        hasEnoughRequests: false,
        showUpdateRecipientEmailModal: false,
        RecipientEmail: {
            value: "",
            errors: {},
            rules: { required: true, regex: { pattern: /^\S+@\S+\.\S+$/, message: "Please enter a valid email address" } }
        },
        showContactUsModal: false,
    }
});

export const { setBulkW8RequestConfirmationModal, setSelectW8Form, setGetW8FormsModalOpen, setW8Forms, setProceedWithW8RequestModalOpen, setW8FormAllRequiredFieldsTouched, setPrepayRequestModalOpen, setPrepayRequests, setPayWithPrepayModalOpen, setRequestedCount, setPayWithPaymentModalOpen, setEstimedTaxModalOpen, setPrepayRequestFieldsTouch, setW8RequestedCountModalOpen, setLoadingState, setBuyingPlan, setW8Fees, setIsSelectAll, setHasEnoughRequests, setShowUpdateRecipientEmailModal, setRecipientEmail, setShowContactUsModal } = actions;
